// 公共组件版权信息
export default {
   'copyright.desc1': 'Alwayscontrol system copyright: Always-control Technology Co.,Ltd.',
   'copyright.desc2': 'Website filing information: ICP No. 2021169764',
   'copyright.desc3': 'Contact: xuheng@alwayscontrol.com.cn',
}
 